<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.apoiPayName" style="width: 140px;" size="mini" placeholder="姓名"
                        clearable></el-input>
                        <el-input v-model="formDatas.apoiPayItemDetails" style="width: 140px;" size="mini" placeholder="支出明细描述"
                        clearable></el-input>
                    <el-select v-model="formDatas.apoiPayDt" size="mini" clearable placeholder="支付部门"
                        style="width: 150px" @change="partserch">
                        <el-option label="公司" value="公司"></el-option>
                        <el-option label="市场" value="市场"></el-option>
                    </el-select>
                    <el-input v-model="formDatas.apoiFeiRelationClass" style="width: 140px;" size="mini" placeholder="费用分摊"
                        clearable></el-input>
                    <el-select size="mini" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="IsSerch = true;"
                        style="margin-left: 10px">更多</el-button>
                    <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button>
                    <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button>
                    <el-dropdown size="mini" split-button type="warning" style="margin:0 10px;" @click="Out()"
                        @command="Out">
                        导出
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="background-color: #E6A23C;color: white;"
                                command="1">导出全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增台账</el-button>

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="apoiId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-dialog width="80%" top="8vh" :wrapperClosable="false" :title="edit == true ? '编辑台账' : '新增台账'"
                :before-close="handleClose" :visible.sync="dialog">
                <el-form ref="formRef" label-width="120px" size="mini" :model="form" label-position="left"
                    :rules="rules" style="height:70vh">
                    <div
                        style="width: 100%;height: 100%; overflow-y: auto;padding: 50px 50px 15px;overflow-x: hidden;display: flex;">
                        <div style="width: 50%;">
                            <el-form-item label="支付渠道" prop="appcId">
                                <el-select v-model="form.appcId" placeholder="请选择" filterable clearable
                                    style="width: 150px;">
                                    <el-option v-for="(item, index) in appcId_arr" :label="item.appcName"
                                        :value="item.appcId" :key="item.appcId"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="支付日期" prop="apoiPayDate">
                                <el-date-picker v-model="form.apoiPayDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择日期" style="width: 150px;">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="支付部门" prop="apoiPayDt">
                                <el-select v-model="form.apoiPayDt" placeholder="请选择" @change="departmentChange"
                                    style="width: 100px;">
                                    <el-option label="公司" value="公司"></el-option>
                                    <el-option label="市场" value="市场"></el-option>
                                </el-select>
                                <el-select v-model="form.apoiPayDtAddressId" placeholder="请选择" filterable clearable
                                    v-if="form.apoiPayDt == '公司'" style="width: 150px;" @change="appiNameChange">
                                    <el-option v-for="(item, index) in company_arr" :label="item.appiName"
                                        :value="item.appiId" :key="item.appiId"></el-option>
                                </el-select>
                                <el-input v-model="form.apoiPayDtAddress" style="width: 150px;" placeholder="请输入"
                                    v-if="form.apoiPayDt == '市场'"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="支付地点" prop="apoiPayDtAddress">
                                <el-input v-model="form.apoiPayDtAddress" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item> -->
                            <el-form-item label="姓名" prop="apoiPayName">
                                <el-select v-model="isName" placeholder="请选择" @change="isNameChange"
                                    style="width: 100px;">
                                    <el-option label="公司" :value="1"></el-option>
                                    <el-option label="市场" :value="2"></el-option>
                                </el-select>
                                <el-select v-model="form.auId" placeholder="请选择" filterable clearable v-if="isName == 2"
                                    style="width: 150px;" @change="auIdChange">
                                    <el-option v-for="(item, index) in Name_arr" :label="item.auName" :value="item.auId"
                                        :key="item.auId"></el-option>
                                </el-select>
                                <el-input v-model="form.apoiPayName" style="width: 150px;" placeholder="请输入公司"
                                    v-if="isName == 1"></el-input>
                            </el-form-item>
                            <el-form-item label="客户类型" prop="apoiCustomerType">
                                <el-input v-model="form.apoiCustomerType" style="width: 150px;"
                                    placeholder="请输入客户类型"></el-input>
                            </el-form-item>
                            <el-form-item label="支出明细" prop="apoiPayItem">
                                <el-select v-model="form.apoiPayItem" placeholder="请选择">
                                    <el-option label="支付" value="支付"></el-option>
                                    <el-option label="内部报销" value="内部报销"></el-option>
                                    <el-option label="采购" value="采购"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="支出明细描述" prop="apoiPayItemDetails">
                                <el-input v-model="form.apoiPayItemDetails" style="width: 50%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="报销支付文件" prop="apoiPayFiles">
                                <my-upload ref="Imgupload2" @fileChange="TextFileChange" :filearr="TextFileList"
                                    @removeAfter="removeAfter2" :limit="9" style="margin: 10px 5px 5px;" type="text"
                                    @textFIlePreview="textFIlePreview">
                                </my-upload>
                            </el-form-item>
                        </div>
                        <div style="width: 50%;">
                            <el-form-item label="支出金额" prop="apoiMoneyPay">
                                <el-input v-model="form.apoiMoneyPay" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="收入金额" prop="apoiMoneyIn">
                                <el-input v-model="form.apoiMoneyIn" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="费用分摊" prop="apoiFeiRelation">
                                <el-select v-model="form.apoiFeiRelation" placeholder="请选择"
                                    @change="apoiFeiRelationChange" style="width: 100px;">
                                    <el-option label="公司" value="公司"></el-option>
                                    <el-option label="市场" value="市场"></el-option>
                                    <el-option label="客服部" value="客服部"></el-option>
                                    <el-option label="宋总个人" value="宋总个人"></el-option>
                                </el-select>
                                <el-select v-model="form.apoiFeiRelationClassId" placeholder="请选择分类" filterable
                                    clearable style="width: 150px;" @change="typeOtherChange">
                                    <el-option v-for="(item, index) in gsType" :label="item.appiName"
                                        :value="item.appiId" :key="item.appiId"></el-option>
                                </el-select>
                                <el-input v-model="form.apoiFeiRelationClass" style="width: 180px;"
                                    placeholder="请输入费用名称" v-if="form.apoiFeiRelationClassId === 0"></el-input>
                            </el-form-item>
                            <el-form-item label="是否有发票" prop="apoiReceiptHas">
                                <el-select v-model="form.apoiReceiptHas" placeholder="请选择" clearable>
                                    <el-option label="是" value="是"></el-option>
                                    <el-option label="否" value="否"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="发票归属" prop="apoiReceiptBelong">
                                <el-select v-model="form.apoiReceiptBelong" placeholder="请选择" clearable>
                                    <el-option label="报销单" value="报销单"></el-option>
                                    <el-option label="合思系统" value="合思系统"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="发票类型" prop="apoiReceiptType">
                                <el-select v-model="form.apoiReceiptType" placeholder="请选择" clearable>
                                    <el-option label="专票" value="专票"></el-option>
                                    <el-option label="普票" value="普票"></el-option>
                                    <el-option label="替票" value="替票"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="快递单号" prop="apoiTrackingNumber">
                                <el-input v-model="form.apoiTrackingNumber" style="width: 50%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="备注" prop="apoiDes">
                                <el-input v-model="form.apoiDes" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="报销支付截图" prop="apoiPayPic">
                                <my-upload ref="Imgupload" @fileChange="fileChange" :filearr.sync="fileList"
                                    @removeAfter="removeAfter" :limit="9" style="margin: 10px 5px 5px;">
                                </my-upload>
                            </el-form-item>
                           
                        </div>


                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="SureBtn">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 筛选 -->
            <el-dialog title="更多搜索" :visible.sync="IsSerch" width="70%" top="8vh" :close-on-click-modal="false">
                <div style=" width: 98%; height:400px;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formDatas" :model="formDatas" label-position="left" label-width="130px"
                            @submit.native.prevent>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="支付部门">
                                    <el-select v-model="formDatas.apoiPayDt" placeholder="请选择" style="width: 100px;">
                                        <el-option label="公司" value="公司"></el-option>
                                        <el-option label="市场" value="市场"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="支付日期">
                                    <el-date-picker v-model="formDatas.apoiPayDateStart" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                    <span style="margin: 0 10px;">-</span>
                                    <el-date-picker v-model="formDatas.apoiPayDateEnd" type="date"
                                        value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 44%;">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="支付地点">
                                    <el-input v-model="formDatas.apoiPayDtAddress" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="客户类型">
                                    <el-input v-model="formDatas.apoiCustomerType" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="支出明细">
                                    <el-select v-model="formDatas.apoiPayItem" placeholder="请选择">
                                        <el-option label="支付" value="支付"></el-option>
                                        <el-option label="内部报销" value="内部报销"></el-option>
                                        <el-option label="采购" value="采购"></el-option>
                                    </el-select>
                                </el-form-item>

                            </div>
                            <div style="width: 50%; display: inline-block">
                                <el-form-item label="支付渠道">
                                    <el-select v-model="formDatas.appcId" placeholder="请选择">
                                        <el-option v-for="item in appcId_arr || []" :label="item.appcName"
                                            :value="item.appcId" :key="item.appcId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="是否有发票">
                                    <el-select v-model="formDatas.apoiReceiptHas" placeholder="请选择" clearable>
                                        <el-option label="是" value="是"></el-option>
                                        <el-option label="否" value="否"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="发票归属">
                                    <el-select v-model="formDatas.apoiReceiptBelong" placeholder="请选择" clearable>
                                        <el-option label="报销单" value="报销单"></el-option>
                                        <el-option label="合思系统" value="合思系统"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="发票类型">
                                    <el-select v-model="formDatas.apoiReceiptType" placeholder="请选择" clearable>
                                        <el-option label="专票" value="专票"></el-option>
                                        <el-option label="普票" value="普票"></el-option>
                                        <el-option label="替票" value="替票"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="快递单号">
                                    <el-input v-model="formDatas.apoiTrackingNumber" style="width: 50%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                            </div>
                            <el-form-item label="费用分摊">
                                <el-select v-model="formDatas.apoiFeiRelation" placeholder="请选择"
                                    @change="apoiFeiRelationChange" style="width: 100px;">
                                    <el-option label="公司" value="公司"></el-option>
                                    <el-option label="市场" value="市场"></el-option>
                                    <el-option label="客服部" value="客服部"></el-option>
                                    <el-option label="宋总个人" value="宋总个人"></el-option>
                                </el-select>
                                <el-select v-model="formDatas.apoiFeiRelationClassId" placeholder="请选择分类" filterable
                                    clearable style="width: 150px;" @change="typeOtherChange2">
                                    <el-option v-for="(item, index) in gsType" :label="item.appiName"
                                        :value="item.appiId" :key="item.appiId"></el-option>
                                </el-select>
                                <el-input v-model="formDatas.apoiFeiRelationClass" style="width: 180px;"
                                    placeholder="请输入费用名称" v-if="formDatas.apoiFeiRelationClassId === 0"></el-input>
                            </el-form-item>
                        </el-form>

                    </div>
                </div>
                <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                    <el-button type="primary" @click="partserch(), IsSerch = false"
                        style="margin-left: 100px">立即搜索</el-button>
                    <el-button @click="closeSizer()" style="margin-left: 200px">取消</el-button>
                </div>

            </el-dialog>
            <!-- 批量导入 -->
            <el-dialog title="批量导入" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
                style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>
                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://trainapp.aojuai.com/assets/excel/purchaseoutin.xlsx', '支出收入记录模板')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%"
                        :virtual-scroll-option="virtualScrollOption" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div style="margin: 10px;font-size: 18px;" v-if="bulkData.length != 0">
                    <span style="color: #0080FF;">一共{{ importData.numAll }}条;</span>
                    <span style="color: #0E9A00;margin-left: 5px;">成功{{ importData.numSuccess }}条;</span>
                    <span style="color: red;margin-left: 5px;">失败{{ importData.numFail }}条</span>
                    <span style="color: #E6A23C;margin-left: 5px;">信息不完整{{ importData.numUnWhole }}条</span>
                </div>
                <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                    <!-- <el-button @click="bulkImportClose">取 消</el-button> -->
                    <el-button type="success" @click="bulkImportClick">确定导入</el-button>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
let Base64 = require('js-base64').Base64
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    getAjPurchaseOutInList, addAjPurchaseOutIn, updateAjPurchaseOutIn, deleteAjPurchaseOutIn, getAjPurchasePublicItemList,
    getAjPurchasePayChannelList, getAjUserListAssets, uploadAjPurchaseOutIn, uploadImportAjPurchaseOutIn
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            TextFileList: [],
            userid: '',
            virtualScrollOption: {
                // 是否开启
                enable: true,
            },
            columnsImport: [

                {
                    field: "status",
                    key: "status",
                    title: "状态",
                    width: 150,
                    align: "center",
                    fixed: 'left',
                    filter: {
                        filterList: [
                            { value: 0, label: '成功', selected: false },
                            { value: 1, label: '失败', selected: false },
                            { value: 3, label: '信息不完整', selected: false }
                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            // console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            this.searchByNameField(labels, 'status');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameField([]);
                        },
                        // max height
                        maxHeight: 120,

                    },
                },
                {
                    field: "statusMsg",
                    key: "statusMsg",
                    title: "状态备注",
                    width: 150,
                    align: "center",
                    fixed: 'left',
                },
                {
                    field: "appcName",
                    key: "appcName",
                    title: "支付渠道",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag>{row.appcName}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "apoiPayDate",
                    key: "apoiPayDate",
                    title: "支付日期",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "apoiPayDt",
                    key: "apoiPayDt",
                    title: "支付部门",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "apoiPayDtAddress",
                    key: "apoiPayDtAddress",
                    title: "支付地点",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "apoiPayName",
                    key: "apoiPayName",
                    title: "姓名",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "apoiCustomerType",
                    key: "apoiCustomerType",
                    title: "客户类型",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "apoiPayItem",
                    key: "apoiPayItem",
                    title: "支出明细",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "apoiPayItemDetails",
                    key: "apoiPayItemDetails",
                    title: "支出明细描述",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "apoiMoneyPay",
                    key: "apoiMoneyPay",
                    title: "支出金额",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "apoiMoneyIn",
                    key: "apoiMoneyIn",
                    title: "收入金额",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "apoiFeiRelation",
                    key: "apoiFeiRelation",
                    title: "费用分摊",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "apoiFeiRelationClass",
                    key: "apoiFeiRelationClass",
                    title: "费用分类",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "apoiReceiptHas",
                    key: "apoiReceiptHas",
                    title: "是否有发票",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "apoiReceiptBelong",
                    key: "apoiReceiptBelong",
                    title: "发票归属",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "apoiReceiptType",
                    key: "apoiReceiptType",
                    title: "发票类型",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "apoiTrackingNumber",
                    key: "apoiTrackingNumber",
                    title: "快递单号",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "apoiDes",
                    key: "apoiDes",
                    title: "备注",
                    align: "center",
                    edit: false,
                    width: 150,
                },
            ],
            bulkData: [],
            importData: {},
            bulkImport: false,
            IsSerch: false,
            Name_arr: [],//
            fileList: [],
            gsType: [],//费用分类-公司
            appcId_arr: [],//支付渠道
            company_arr: [],//公司部门
            isDepartment: '',//部门选项:1公司2市场
            isName: 1,//姓名选项:1公司2市场
            key: 'apoiId',
            dialog: false,
            edit: false,
            formCopy: {
                apoiPayDtAddressId: '',
                appcId: '',
                apoiPayDate: '',
                apoiPayDt: '',
                apoiPayDtAddress: '',
                apoiPayName: '',
                auId: '',
                apoiCustomerType: '',
                apoiPayItem: '',
                apoiPayItemDetails: '',
                apoiMoneyPay: '',
                apoiMoneyIn: '',
                apoiFeiRelation: '',
                apoiFeiRelationClassId: '',
                apoiFeiRelationClass: '',
                apoiReceiptHas: '',
                apoiReceiptBelong: '',
                apoiReceiptType: '',
                apoiPayPic: '',
                apoiTrackingNumber: '',
                apoiDes: '',
            },

            form: {
                apoiPayDtAddressId: '',
                appcId: '',
                apoiPayDate: '',
                apoiPayDt: '',
                apoiPayDtAddress: '',
                apoiPayName: '',
                auId: '',
                apoiCustomerType: '',
                apoiPayItem: '',
                apoiPayItemDetails: '',
                apoiMoneyPay: '',
                apoiMoneyIn: '',
                apoiFeiRelation: '',
                apoiFeiRelationClassId: '',
                apoiFeiRelationClass: '',
                apoiReceiptHas: '',
                apoiReceiptBelong: '',
                apoiReceiptType: '',
                apoiPayPic: '',
                apoiPayFiles: '',
                apoiTrackingNumber: '',
                apoiDes: '',
            },
            rules: {
                appcId: [{
                    required: true,
                    message: '请选择支付渠道',
                    trigger: 'change'
                }],
                apoiPayDate: [{
                    required: true,
                    message: '请选择日期',
                    trigger: 'change'
                }],
                // apoiMoneyIn: [{
                //     required: true,
                //     message: '请输入金额或者输入0',
                //     trigger: 'blur'
                // }],
                // apoiMoneyPay: [{
                //     required: true,
                //     message: '请输入金额或者输入0',
                //     trigger: 'blur'
                // }],
            },
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 20,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "appcName",
                    key: "appcName",
                    title: "支付渠道",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag>{row.appcName}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "apoiPayDate",
                    key: "apoiPayDate",
                    title: "支付日期",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "apoiPayDt",
                    key: "apoiPayDt",
                    title: "支付部门",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "apoiPayDtAddress",
                    key: "apoiPayDtAddress",
                    title: "支付地点",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "apoiPayName",
                    key: "apoiPayName",
                    title: "姓名",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "apoiCustomerType",
                    key: "apoiCustomerType",
                    title: "客户类型",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "apoiPayItem",
                    key: "apoiPayItem",
                    title: "支出明细",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "apoiPayItemDetails",
                    key: "apoiPayItemDetails",
                    title: "支出明细描述",
                    align: "center",
                    edit: false,
                    width: 400,
                },
                {
                    field: "apoiMoneyPay",
                    key: "apoiMoneyPay",
                    title: "支出金额",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "apoiMoneyIn",
                    key: "apoiMoneyIn",
                    title: "收入金额",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "apoiFeiRelation",
                    key: "apoiFeiRelation",
                    title: "费用分摊",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "apoiFeiRelationClass",
                    key: "apoiFeiRelationClass",
                    title: "费用分类",
                    align: "center",
                    edit: false,
                    width: 130,
                },
                {
                    field: "apoiReceiptHas",
                    key: "apoiReceiptHas",
                    title: "是否有发票",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "apoiReceiptBelong",
                    key: "apoiReceiptBelong",
                    title: "发票归属",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "apoiReceiptType",
                    key: "apoiReceiptType",
                    title: "发票类型",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "apoiPayPic",
                    key: "apoiPayPic",
                    title: "报销支付截图",
                    align: "center",
                    edit: false,
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.apoiPayPic ? <el-image ref="scrImg" id="scrimg" src={row.apoiPayPic.split(',')[0]} alt="" fit="fill" style="width: 50px;height: 50px;"
                                        previewSrcList={row.apoiPayPic.split(',')}></el-image> : <span></span>
                                }

                            </span>
                        );
                    },
                },
                {
                    field: "apoiPayFiles",
                    key: "apoiPayFiles",
                    title: "报销支付文件",
                    align: "center",
                    edit: false,
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.apoiPayFiles ?(JSON.parse(row.apoiPayFiles)|| []).map( (item)=> {
                                        var that =this
                                            return <el-tag style="color:red;margin:5px;"  on-click={() => this.TextPreView(item.url)}>{item.name}</el-tag>
                                        }) : <span></span>
                                }

                            </span>
                        );
                    },
                },
                {
                    field: "apoiTrackingNumber",
                    key: "apoiTrackingNumber",
                    title: "快递单号",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "apoiDes",
                    key: "apoiDes",
                    title: "备注",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            sitId: '',
            post: null,
            formDatas: {
                apoiFeiRelationClass:'',
                apoiPayItemDetails:'',
                appcId: '',
                apoiPayDateStart: '',
                apoiPayDateEnd: '',
                apoiPayDt: '',
                apoiPayDtAddress: '',
                apoiPayName: '',
                apoiCustomerType: '',
                apoiPayItem: '',
                apoiFeiRelation: '',
                apoiFeiRelationClassId: '',
                apoiFeiRelationClass: '',
                apoiReceiptHas: '',
                apoiReceiptBelong: '',
                apoiReceiptType: '',
                apoiTrackingNumber: '',
                currentPage: 1,
                pageSize: 20,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.userid = window.localStorage.getItem('userid');
        console.log(this.userid)
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
        getAjPurchasePayChannelList().then(res => {
            this.appcId_arr = res.data
        })
    },
    mounted() { },
    methods: {
        TextPreView(val){
            window.open('https://filepreview.aojuai.com/onlinePreview?url=' + encodeURIComponent(Base64.encode(
                val)));
        },
        textFIlePreview(index) {
            window.open('https://filepreview.aojuai.com/onlinePreview?url=' + encodeURIComponent(Base64.encode(
                this.form.apoiPayFiles[index].url)));
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },

        Out(command) {
            console.log(command);
            if (this.selectedRowKeysCollection.length == 0 && !command) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && !command) {
                console.log('开始导出', this.selectedRowKeysCollection)
                const bulkdata = {
                    exportType: 2,
                    apoiIds: this.selectedRowKeysCollection.toString(),
                    ...this.formDatas
                }
                var s = qs.stringify(bulkdata);
                this.openLoading()
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/aj-purchase-out-in/exportAjPurchaseOutIn',
                    data: s,
                    // withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('userid'),
                    }
                }).then(function (res) {
                    if (res.data) {
                        const decodedString = decodeURIComponent(res.headers.filename);
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", decodedString);
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            } else {
                const bulkdata = {
                    exportType: 1,
                    ...this.formDatas
                }
                var s = qs.stringify(bulkdata);
                this.openLoading()
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/aj-purchase-out-in/exportAjPurchaseOutIn',
                    data: s,
                    // withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('userid')
                    }
                }).then(function (res) {
                    if (res.data) {
                        const decodedString = decodeURIComponent(res.headers.filename);
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", decodedString);
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            }
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                this.openLoading()
                uploadImportAjPurchaseOutIn({
                    sitId: this.sitId
                }).then(res => {
                    if (res) {
                        this.loadings.close()
                        this.getList()
                        this.bulkImport = false;
                        this.bulkData = [];
                        this.bulkDataCopy = [];
                        this.sitId = '';
                        this.$refs['bulk'].clearFiles()

                        this.$message({
                            type: 'success',
                            message: '导入成功!'
                        });
                    }

                })
            }

        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjPurchaseOutIn(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;
            })
        },
        searchByNameField(labels, id) {
            this.bulkData = this.bulkDataCopy.filter(
                (x) => labels.length === 0 || labels.includes(x[id]),
            );
        },
        closeSizer() {
            console.log("1");
            this.formDatas = {
                apoiFeiRelationClass:'',
                appcId: '',
                apoiPayDateStart: '',
                apoiPayDateEnd: '',
                apoiPayDt: '',
                apoiPayDtAddress: '',
                apoiPayName: '',
                apoiCustomerType: '',
                apoiPayItem: '',
                apoiFeiRelation: '',
                apoiFeiRelationClassId: '',
                apoiFeiRelationClass: '',
                apoiReceiptHas: '',
                apoiReceiptBelong: '',
                apoiReceiptType: '',
                apoiTrackingNumber: '',
                currentPage: 1,
                pageSize: 20,
            };
            this.IsSerch = false;
            this.partserch()
        },
        appiNameChange(e) {
            if (e) {
                this.company_arr.forEach((item, index) => {
                    if (e === item.appiId) {
                        this.form.apoiPayDtAddress = item.appiName
                    }
                })
            }
        },
        removeAfter(file) {
            const url = this.form.apoiPayPic.findIndex(item => item === file)
            this.form.apoiPayPic.splice(url, 1)
        },
        removeAfter2(file) {
            const url = this.form.apoiPayFiles.findIndex(item => item.url === file)
            this.form.apoiPayFiles.splice(url, 1)
        },
        TextFileChange(file) {
            if (this.form.apoiPayFiles && this.form.apoiPayFiles.length > 0) {
                this.form.apoiPayFiles.push(...file)
            } else {
                this.$set(this.form, 'apoiPayFiles', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        // 上传图片
        fileChange(file) {
            if (this.form.apoiPayPic && this.form.apoiPayPic.length > 0) {
                this.form.apoiPayPic.push(...file)
            } else {
                this.$set(this.form, 'apoiPayPic', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        typeOtherChange(e) {
            this.form.apoiFeiRelationClass = '';
            if (e) {
                this.gsType.forEach((item, index) => {
                    if (e == item.appiId) {
                        this.form.apoiFeiRelationClass = item.appiName
                    }
                })
            }
            this.$forceUpdate()
        },
        typeOtherChange2(e) {
            this.formDatas.apoiFeiRelationClass = '';
            if (e) {
                this.gsType.forEach((item, index) => {
                    if (e == item.appiId) {
                        this.formDatas.apoiFeiRelationClass = item.appiName
                    }
                })
            }
            this.$forceUpdate()
        },
        // 切换费用分类
        apoiFeiRelationChange(e) {
            this.gsType = [{ appiName: '其他', appiId: 0 }];
            this.form.apoiFeiRelationClassId = this.form.apoiFeiRelationClass = '';
            if (e == '公司') {
                getAjPurchasePublicItemList({ appiType: 2 }).then(res => {
                    this.gsType = res.data.concat(this.gsType)
                })
            } else if (e == '客服部') {
                getAjPurchasePublicItemList({ appiType: 3 }).then(res => {
                    this.gsType = res.data.concat(this.gsType)
                })
            } else if (e == '宋总个人') {
                getAjPurchasePublicItemList({ appiType: 4 }).then(res => {
                    this.gsType = res.data.concat(this.gsType)
                })
            } else if (e == '市场') {
                getAjPurchasePublicItemList({ appiType: 5 }).then(res => {
                    this.gsType = res.data.concat(this.gsType)
                })
            }
            this.$forceUpdate()
        },
        // 获取花名册id
        auIdChange(e) {
            if (e) {
                this.Name_arr.forEach((item, index) => {
                    if (e === item.auId) {
                        this.form.apoiPayName = item.auName
                    }
                })
            }
        },
        // 切换姓名
        isNameChange(e) {
            if (e == 2) {
                this.form.auId = '';
                this.form.apoiPayName = '';
                getAjUserListAssets({ checkStatus: 2, }).then(res => {
                    if (res) {
                        this.Name_arr = res.data
                    }
                })
            } else {
                this.form.apoiPayName = '';
                this.form.auId = '';
            }
        },
        // 切换支付部门
        departmentChange(e) {
            if (e == '公司') {
                this.form.apoiPayDtAddressId = this.form.apoiPayDtAddress = '';
                this.isName = 1;
                this.form.auId = '';
                this.form.apoiPayName = '';
                getAjPurchasePublicItemList({ appiType: 1 }).then(res => {
                    if (res) {
                        this.company_arr = res.data
                    }
                })
            } else {
                this.form.apoiPayDtAddressId = 0;
                this.form.apoiPayDtAddress = '';
                this.isName = 2;
                this.form.apoiPayName = '';
                getAjUserListAssets({ checkStatus: 2, }).then(res => {
                    if (res) {
                        this.Name_arr = res.data
                    }
                })
            }
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjPurchaseOutIn({ apoiIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjPurchaseOutIn({ apoiIds: row.apoiId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.gsType = [{ appiName: '其他', appiId: 0 }];
                if (data.apoiPayDt == '公司') {
                    getAjPurchasePublicItemList({ appiType: 1 }).then(res => {
                        if (res) {
                            this.company_arr = res.data
                        }
                    })
                }
                if (data.auId) {
                    this.isName = 2;
                    getAjUserListAssets({ checkStatus: 2, }).then(res => {
                        if (res) {
                            this.Name_arr = res.data
                        }
                    })
                }
                if (data.apoiFeiRelation == '公司') {
                    getAjPurchasePublicItemList({ appiType: 2 }).then(res => {
                        this.gsType = res.data.concat(this.gsType)
                    })
                } else if (data.apoiFeiRelation == '客服部') {
                    getAjPurchasePublicItemList({ appiType: 3 }).then(res => {
                        this.gsType = res.data.concat(this.gsType)
                    })
                } else if (data.apoiFeiRelation == '宋总个人') {
                    getAjPurchasePublicItemList({ appiType: 4 }).then(res => {
                        this.gsType = res.data.concat(this.gsType)
                    })
                } else if (data.apoiFeiRelation == '市场') {
                    getAjPurchasePublicItemList({ appiType: 5 }).then(res => {
                        this.gsType = res.data.concat(this.gsType)
                    })
                }
                this.form.apoiPayPic = data.apoiPayPic ? data.apoiPayPic.split(',') : '';
                this.form.apoiPayFiles = data.apoiPayFiles ? JSON.parse(data.apoiPayFiles) : '';
                if (this.form.apoiPayPic.length > 0) {
                    console.log(this.form.apoiPayPic);
                    this.form.apoiPayPic.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img)
                    })
                }
                if (this.form.apoiPayFiles.length > 0) {
                    console.log(this.form.apoiPayFiles);
                       this.TextFileList = this.form.apoiPayFiles
                }
            })
        },
        SureBtn() {
            this.$refs['formRef'].validate(val => {
                if (val) {
                    if (!this.edit) {

                        this.$confirm("是否确定要新增, 是否继续?", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                            .then(() => {
                                var newForm = JSON.parse(JSON.stringify(this.form));
                                console.log(newForm)
                                newForm.apoiPayPic = newForm.apoiPayPic.length > 0 ? newForm.apoiPayPic.filter(item => typeof item === 'string').join(',') : '';
                                newForm.apoiPayFiles = newForm.apoiPayFiles.length > 0 ? JSON.stringify(newForm.apoiPayFiles): '';
                                addAjPurchaseOutIn(newForm).then(res => {
                                    if (res.data) {
                                        this.$message({
                                            type: "success",
                                            message: "新增成功!",
                                        });
                                        this.handleClose()
                                        this.getList()
                                    }
                                })
                            }).catch(() => {
                                this.$message({
                                    type: "info",
                                    message: "已取消",
                                });
                            })
                    } else {
                        this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                            .then(() => {
                                var newForm = JSON.parse(JSON.stringify(this.form));
                                console.log(newForm)
                                newForm.apoiPayPic = newForm.apoiPayPic.length > 0 ? newForm.apoiPayPic.filter(item => typeof item === 'string').join(',') : '';
                                newForm.apoiPayFiles = newForm.apoiPayFiles.length > 0 ? JSON.stringify(newForm.apoiPayFiles): '';
                                updateAjPurchaseOutIn(newForm).then(res => {
                                    if (res.data) {
                                        this.$message({
                                            type: "success",
                                            message: "编辑成功!",
                                        });
                                        this.handleClose()
                                        this.getList()
                                    }
                                })
                            }).catch(() => {
                                this.$message({
                                    type: "info",
                                    message: "已取消",
                                });
                            })
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: '请按要求填写完表单信息',
                        type: 'warning'
                    });
                }
            })


        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.form = this.formCopy;
            this.isName = 1;
            this.fileList = [];
            this.TextFileList = [];
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.apoiId = row.apoiId
                    console.log(jsonObj);
                    updateAjPurchaseOutIn(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjPurchaseOutInList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjPurchaseOutInList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjPurchaseOutInList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>